export class CoreUserAgent {
  static isChrome() {
    return navigator && navigator.userAgent != null && navigator.userAgent.indexOf("Chrome") != -1;
  }
  static isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  static isiOS() {
    return /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
  }
  static isAndroid() {
    return /(Android)/g.test(navigator.userAgent);
  }
  static isTouchDevice() {
    var el = document.createElement("div");
    el.setAttribute("ongesturestart", "return;");
    return typeof el.ongesturestart === "function";
  }
}
